import { render, staticRenderFns } from "./ReferralSidebar.vue?vue&type=template&id=10ba770a&"
import script from "./ReferralSidebar.vue?vue&type=script&lang=js&"
export * from "./ReferralSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ReferralSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports